<template>
  <div class="h-auto relative overflow-hidden px-4 flex flex-wrap dark:bg-gray-900 dark:text-gray-400">
    <div class="container  relative mx-auto relateive py-20 space-y-5 px-0 lg:px-24">
      <h1 class=" font-sans font-extrabold text-2xl leading-tight">Free SchoolBoard App Project.</h1>
      <p>Kami Membuat Aplikasi Khusus untuk mempermudah kegiatan belajar mengajar di saat Pandemi Khusus untuk sekolah & <span class=" text-bold">Gratis</span> dengan ketentuan...</p>
      <li>Kami hanya membantu menyediakan Aplikasi..</li>
      <li>WebApp memerlukan Hosting & domain name yang bisa di sewa dari pihak ke-3</li>
      <li>Hosting adalah tempat aplikasi di pasang agar bisa di akses secara online</li>
      <li>domain name adalah nama link aplikasi seperti: www.namasekolah.com</li>
      <li>Untuk Melihat demo silahkan SignUp & Login</li>
      <li class=" italic">Project ini hanya untuk institusi sekolah resmi</li>
      <li class=" italic">Kami Akan mengirim App Melalui Email setelah sekolah terverifikasi & segera bisa di install di server sekolah</li>
      <li class="text-primary italic">Silahkan Hubungi kami jika tidak memiliki team IT & kami akan membantu dengan senang hati</li>
      <li class="text-primary italic">WhatsApp : 081215969696 atau kunjungi website kami di www.roofel.com</li>
      <button class="bg-primary rounded-lg py-2 px-8 text-white">
        <a href="https://www.roofel.com">
          www.roofel.com
        </a>
      </button>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
